module.exports = __webpack_public_path__ + "media/47.74dff3cd.wav";